










































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Calendar, SearchCondition, CreateRequest } from '@/modules/calendar';
import { FunctionTypes } from '@/enums/functionTypes';
import CreateModal from '@/components/calendar/createModal.vue';
import AvaivaledVue from '@/components/avaivaled.vue';

@Component({
  components: {
    CreateModal,
  }
})
export default class extends AvaivaledVue {
  private get isLoading() { return this.$store.state.calendar.isLoading || this.$store.state.schedule.isLoading; }
  private get pageTitle() { return '予約カレンダー一覧'; }
  private get headerIcon() { return 'far fa-calendar-alt fa-2x'; }

  private get countAll() { return 0; }
  private get condition(): SearchCondition { return this.$store.state.calendar.searchCondition; }
  private get isMini(): boolean { return (this as any).$mq === 'mini'; }
  private get tableDatas(): Calendar[] { return this.$store.state.calendar.list; }
  private showSearchCondition = true;

  private isOpenCreateModal = false;
  private get createRequest(): CreateRequest { return this.$store.state.calendar.createRequest; }

  private loadData() {
    this.$store.dispatch('calendar/getListRequest');
  }
  private mounted() {
    this.loadData();
  }
  private deactivated() {
    this.$destroy();
  }
  private created() {
    this.pageBackCheck(FunctionTypes.Reserve);
  }

  private onPageSizeChange(val: number) { this.condition.perPage = val; }
  private onChangePage() { this.loadData(); }
  private onChangeCondition() {
    this.condition.page = 1;
    this.loadData();
  }
  private onChangeSort( {prop, order}: any ) {
    if (!prop) {
      this.condition.sort = 'date descending';
    } else {
      this.condition.sort = `${prop} ${order}`;
    }
    this.loadData();
  }

  private gotoReservableCount() {
    this.$router.push('/schedule/reservableCount');
  }

  private gotoBaseSchedule() {
    this.$router.push('/schedule/baseSchedule');
  }

  private onCreate() {
    this.$store.dispatch('calendar/resetCreateRequest');
    this.isOpenCreateModal = true;
  }

  private async onCreateRequestDateValidate() {
    const response = await this.$store.dispatch('calendar/confirmedCreateDate');
    if (!response) {
      this.$alert('既に作成されている年月です。', '', {
        type: 'error',
        confirmButtonText: 'OK',
      });
    }
  }

  private async onCreateSend() {
    const calendarId: number = await this.$store.dispatch('calendar/createTemporoaryRequest')
      .catch(() => { const a = 1; });
    if (calendarId > 0) {
      this.$router.push({
        name: 'ScheduleEdit',
        params: {
          calendarId: calendarId.toString(),
        }
      });
    }
  }

  private onEdit(calendarId: string) {
    this.$router.push({
      name: 'ScheduleEdit',
      params: {
        calendarId,
      }
    });
  }

  private onRemove(calendarId: number) {
    const findTableData = this.tableDatas.find((value: Calendar) => {
      return value.calendarId === calendarId;
    });
    if (findTableData !== undefined) {
      const name = `${findTableData.year}年${findTableData.month}月`;
      (this as any).$confirm(
        `${name}の予約カレンダーを削除します。よろしいですか？`, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      })
      .then(async () => {
        const response = await this.$store.dispatch('calendar/removeRequest', calendarId)
          .catch(() => { const a = 1; });
        if (response) {
          this.$notify({
            type: 'success',
            title: '予約カレンダー削除完了',
            message: `${name}のカレンダーを削除しました。`,
            position: 'bottom-right'
          });
          this.loadData();
        }
      })
      .catch();
    }
  }

  private onOutput(calendarId: number) {
    this.$store.dispatch('calendar/outputRequest', calendarId);
  }
}
